import React, { memo } from "react";

import NoData from "../../common-components/no-data";
import SimulationsTable from "./simulations-table";
import SimulationsChart from "./simulations-chart";
import { ArticleContainer, SectionContainer } from "../../clients-dashboard-style";
import { IGetSimulationsData } from "../../../../../services/ClientsDashboardServices.dto";
import { UseGenerateDataError } from "../../hooks/useGenerateData.types";

interface SimulationsDashboardProps {
  data: IGetSimulationsData | null;
  error: UseGenerateDataError;
}

const areEqual = (prevProps: SimulationsDashboardProps, nextProps: SimulationsDashboardProps) => {
  const isEqualData = JSON.stringify(prevProps.data) === JSON.stringify(nextProps.data);
  const isEqualErrorMessage = prevProps.error.simulations === nextProps.error.simulations;
  return isEqualData && isEqualErrorMessage;
};

const SimulationsDashboard = memo(({ data, error }: SimulationsDashboardProps) => {
  if (error.simulations) {
    return <NoData message={error.simulations} />;
  }

  if (!data || Object.keys(data).length < 1) {
    return <NoData message="Genera una búsqueda para mostrar datos" />;
  }

  if (data.overallSimulationsResults.totalSimulations === 0) {
    return <NoData message="No existen datos para las fechas seleccionadas" />;
  }

  return (
    <SectionContainer>
      <ArticleContainer>
        <SimulationsTable data={data} />
      </ArticleContainer>
      <ArticleContainer>
        <SimulationsChart data={data} />
      </ArticleContainer>
    </SectionContainer>
  );
}, areEqual);

export default SimulationsDashboard;
